import React from 'react';
import { DATA_HOOKS } from './BrowserPreviewWidget.constants';
import { BrowserPreviewWidgetProps } from './BrowserPreviewWidget.types';
import PreviewWidget from '../PreviewWidget';
import { st, classes } from './BrowserPreviewWidget.st.css';

/** Browser preview widget */
const BrowserPreviewWidget = ({
  dataHook,
  skin = 'neutral',
  backgroundColor,
  height = '100%',
  width = '100%',
  browserBarSize = 'size12',
  children,
}: BrowserPreviewWidgetProps) => {
  return (
    <PreviewWidget
      className={st(classes.root, {
        skin,
        backgroundColor,
        height,
        width,
        browserBarSize,
      })}
      dataHook={dataHook}
      skin={skin}
      backgroundColor={backgroundColor}
      height={height}
      width={width}
    >
      <div data-hook={DATA_HOOKS.browserBar} className={classes.browserBar}>
        <div className={classes.circlesContainer}>
          <div className={classes.circle} />
          <div className={classes.circle} />
          <div className={classes.circle} />
        </div>
      </div>
      <div data-hook={DATA_HOOKS.browserContent}>{children}</div>
    </PreviewWidget>
  );
};

BrowserPreviewWidget.displayName = 'BrowserPreviewWidget';

export default BrowserPreviewWidget;
